/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import 'styled-components/macro';
import PropTypes from 'prop-types';

import { StyledTabs, Wrap, StyledTabList, TabBtn, StyledTab, StyledTabPanels, StyledTabPanel } from './DataTabs.styles';

const propTypes = {
  data: PropTypes.array,
};

function DataTabs({
  data = [],
  verticalTabs,
  uploadBtn,
  extraCss = () => {},
  css2,
  _activeTab = 0,
  pillStyle = false,
}) {
  const [activeTab, setActiveTab] = useState(_activeTab);
  return (
    <StyledTabs verticalTabs={verticalTabs} pillStyle={pillStyle}>
      <Wrap uploadBtn>
        <StyledTabList css={css2} pillStyle={pillStyle}>
          {data.map((tab, index) => (
            <TabBtn
              key={tab.label}
              isVertical={verticalTabs}
              isPillStyle={pillStyle}
              onClick={() => {
                setActiveTab(index);
              }}>
              <StyledTab css={extraCss(activeTab === index)} active={activeTab === index} pillStyle={pillStyle}>
                {tab.label}
              </StyledTab>
            </TabBtn>
          ))}
        </StyledTabList>
        {uploadBtn ?? uploadBtn}
      </Wrap>

      <StyledTabPanels
        css={`
          width: 100%;
        `}>
        <StyledTabPanel key={data?.find((x, i) => i === activeTab)?.label} active>
          {data?.find((x, i) => i === activeTab)?.content}
        </StyledTabPanel>
      </StyledTabPanels>
    </StyledTabs>
  );
}

DataTabs.propTypes = propTypes;

export default DataTabs;
